import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './PendingInvoice.styles';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Button } from '@/components/UI/Button/Button';
import { ROUTES } from '@/constants/routes';
import { useCustomPush } from '@/components/CustomLink/CustomLink.hooks';

export const PendingInvoice = () => {
  const { t } = useTranslation();
  const customPush = useCustomPush();

  function buyPlan() {
    customPush(ROUTES.buyPlan);
  }

  return (
    <S.Box>
      <div>
        <Typography.Title $variant="2">
          {t('pages.cabinet.invoice_is_waiting_payment')}
        </Typography.Title>

        <S.Text $variant="3">
          {t('pages.cabinet.package_expires', {
            packageName: 'Gold',
            from: '25.06.2022',
            to: '30.06.2022',
            amount: '300',
          })}
        </S.Text>
      </div>
      <Button appearance="secondary" size="s" onClick={buyPlan}>
        {t('common.pay')}
      </Button>
    </S.Box>
  );
};
